module.exports = __webpack_public_path__ + "img/10.c50697c4.png";